import { StatusBadge } from "@/components/wheel/StatusBadge";

function scoreColor(score) {
  const v = Number(score) || 0;
  if (v > 0.15) return "#10B981";
  if (v < -0.15) return "#F87171";
  return "var(--hoip-text-secondary)";
}

function scoreBg(score) {
  const v = Number(score) || 0;
  if (v > 0.15) return "linear-gradient(135deg, rgba(16,185,129,0.16), rgba(16,185,129,0.02))";
  if (v < -0.15) return "linear-gradient(135deg, rgba(248,113,113,0.14), rgba(248,113,113,0.02))";
  return "transparent";
}

/**
 * 11 GICS-sector tiles. Dimensions: sector, score, tone, timestamp.
 * Click is a no-op placeholder for a later ticker-list drill-down.
 */
export function SectorHeatmapGrid({
  items,
  testid,
  bullishKey = "mostBullishTicker",
  bearishKey = "mostBearishTicker",
  coverageKey = "stocksCovered",
  mentionsKey = "mentions7d",
  extraLine,
}) {
  const rows = items || [];
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2" data-testid={testid}>
      {rows.map((s) => {
        const dir = Number(s.score) >= 0 ? "▲" : "▼";
        return (
          <button
            key={s.sector}
            type="button"
            className="border p-2.5 text-left min-w-0"
            style={{ borderColor: "var(--hoip-border)", background: scoreBg(s.score) }}
            title="Sector drill-down is not wired yet"
            data-testid={`sector-tile-${s.sector}`}
          >
            <div className="flex items-start justify-between gap-1">
              <div className="text-[11px] font-bold leading-tight truncate">{s.sector}</div>
              <span className="font-mono-data text-[12px] shrink-0" style={{ color: scoreColor(s.score) }}>
                {dir} {Number(s.score) > 0 ? "+" : ""}{Number(s.score).toFixed(2)}
              </span>
            </div>
            <div className="mt-1">
              <StatusBadge
                tier="info"
                text={s.tone}
                title={`As of ${s.timestamp || "—"}. Score is mock. Not a trade recommendation.`}
              />
            </div>
            <div className="text-[9px] mt-1.5 space-y-0.5" style={{ color: "var(--hoip-text-tertiary)" }}>
              <div>{s[coverageKey] ?? "—"} names · {s[mentionsKey] ?? "—"} 7d mentions</div>
              <div>▲ {s[bullishKey] || "—"} · ▼ {s[bearishKey] || "—"}</div>
              {typeof extraLine === "function" ? extraLine(s) : null}
            </div>
          </button>
        );
      })}
    </div>
  );
}
